/**
 * Site-wide constants. Swap BRAND / SITE_URL here and it propagates everywhere.
 */
export const BRAND = "Conduit";
export const SITE_TAGLINE = "Zero-setup, role-ready AI agents";
export const SITE_DESCRIPTION =
  "Conduit gives every role in your business a pre-built AI agent — opinionated workflows, integrations, and prompts out of the box. No setup, no prompt library to curate.";
export const SITE_URL = "https://conduit-bb8.pages.dev";
export const SUPPORT_EMAIL = "hello@conduit-bb8.pages.dev";
